import Vue from 'vue'
import VueRouter from 'vue-router'
import http from '@/utils/http'

Vue.use(VueRouter)

const routes = [
  { path: '/index', redirect: '/' },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue'),
    meta:{
      title:'骆驼电池官网'
    }
  },
  {
    path: '/brand-story/introduce',
    name: 'introduce',
    component: () => import(/* webpackChunkName: "brand-story" */ '../views/brand-story/introduce.vue'),
    meta:{
      title:'品牌故事'
    }
  },
  {
    path: '/product/product-line',
    name: '/product/product-line',
    component: () => import(/* webpackChunkName: "product" */ '../views/product/product-line.vue'),
    meta:{
      title:'骆驼产品'
    }
  },
  {
    path: '/product/index',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '../views/product/index.vue'),
    meta:{
      title:'骆驼产品',
      keepAlive:true
    }
  },
  {
    path: '/product/detail',
    name: '/product/detail',
    component: () => import(/* webpackChunkName: "product" */ '../views/product/product-detail.vue'),
    meta:{
      title:'骆驼产品'
    }
  },
  {
    path: '/solution/e-commerce',
    name: 'solution',
    component: () => import(/* webpackChunkName: "solution" */ '../views/solution/e-commerce.vue'),
    meta:{
      title:'电商服务'
    }
  },
  {
    path: '/solution/government',
    name: 'solution',
    component: () => import(/* webpackChunkName: "solution" */ '../views/solution/government.vue'),
    meta:{
      title:'政府机关能源服务',
      keepAlive:true
    }
  },
  {
    path: '/solution/public-utilities',
    name: 'solution',
    component: () => import(/* webpackChunkName: "solution" */ '../views/solution/public-utilities.vue'),
    meta:{
      title:'公共事业交通',
      keepAlive:true
    }
  },
  {
    path: '/about-lt/brand-strength',
    name: 'about-lt',
    component: () => import(/* webpackChunkName: "about-lt" */ '../views/about-lt/brand-strength.vue'),
    meta:{
      title:'品牌实力'
    }
  },
  {
    path: '/about-lt/brand-technology',
    name: 'about-lt',
    component: () => import(/* webpackChunkName: "about-lt" */ '../views/about-lt/brand-technology.vue'),
    meta:{
      title:'品牌技术'
    }
  },
  {
    path: '/about-lt/battery-recycling',
    name: 'about-lt',
    component: () => import(/* webpackChunkName: "about-lt" */ '../views/about-lt/battery-recycling.vue'),
    meta:{
      title:'回收业务'
    }
  },
  {
    path: '/info/battery-knowledge',
    name: 'battery-knowledge',
    component: () => import(/* webpackChunkName: "info" */ '../views/info/battery-knowledge.vue'),
    meta:{
      title:'电池知识',
      keepAlive:true
    }
  },
  {
    path: '/info/maintain',
    name: 'maintain',
    component: () => import(/* webpackChunkName: "info" */ '../views/info/maintain.vue'),
    meta:{
      title:'电池知识'
    }
  },
  {
    path: '/info/replace',
    name: 'maintain',
    component: () => import(/* webpackChunkName: "info" */ '../views/info/replace.vue'),
    meta:{
      title:'电池知识'
    }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "brand-story" */ '../views/download.vue'),
    meta:{
      title:'下载中心'
    }
  },
  {
    path: '/press-center/index',
    name: 'press-center',
    component: () => import(/* webpackChunkName: "press-center" */ '../views/press-center/index.vue'),
    meta:{
      title:'新闻中心'
    }
  },
  {
    path: '/press-center/business-movement',
    name: 'press-center',
    component: () => import(/* webpackChunkName: "press-center" */ '../views/press-center/business-movement.vue'),
    meta:{
      title:'企业动态',
      keepAlive:true
    }
  },
  {
    path: '/press-center/product-dynamics',
    name: 'press-center',
    component: () => import(/* webpackChunkName: "press-center" */ '../views/press-center/product-dynamics.vue'),
    meta:{
      title:'产品动态',
      keepAlive:true
    }
  },
  {
    path: '/press-center/video-zone',
    name: 'press-center',
    component: () => import(/* webpackChunkName: "press-center" */ '../views/press-center/video-zone.vue'),
    meta:{
      title:'视频专区'
    }
  },
  {
    path: '/press-center/detail',
    name: '/press-center/detail',
    component: () => import(/* webpackChunkName: "press-center" */ '../views/press-center/detail.vue'),
    meta:{
      title:'新闻详情'
    }
  },
  {
    path: '/contact-us/index',
    name: 'contact-us',
    component: () => import(/* webpackChunkName: "contact-us" */ '../views/contact-us/index.vue'),
    meta:{
      title:'联系我们'
    }
  },
  {
    path: '/buy/index',
    name: 'buy',
    component: () => import(/* webpackChunkName: "buy" */ '../views/buy/index.vue'),
    meta:{
      title:'在哪儿买'
    }
  },
  {
    path: "/batterSearch",
    name: "batterSearch",
    meta:{
      title:"查询适配",
    },
    component:()=>import("@/views/batterySearch/index.vue")
  },
  {
    path: "/disclaimer/index",
    name: "disclaimer",
    meta:{
      title:"免责声明",
    },
    component:()=>import("@/views/disclaimer/index.vue")
  },
  // {
  //   path: "/swiper",
  //   name: "disclaimer",
  //   meta:{
  //     title:"免责声明",
  //   },
  //   component:()=>import("@/views/swiper.vue")
  // },
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next)=>{
  window.scrollTo(0,0);
  document.title = to.meta.title
  Vue.prototype.$path = to.path
  webRecordLog()
  next()
})

function webRecordLog(params) {
  http.get("/userLog/webRecordLog", {
    name:'visit'
  }).then((res) => {
    
  });
}
export default router
